import React from 'react';
import { Card, Flex, Typography } from 'antd';
import {
  FilePdfOutlined,
  FileImageOutlined,
  FileWordOutlined,
  FileExcelOutlined,
  FilePptOutlined,
  FileUnknownOutlined,
  PlaySquareOutlined,
  FileTextOutlined,
  CloseOutlined,
} from '@ant-design/icons';

const { Text } = Typography;

// Icon constants
const FILE_TYPE_ICONS = {
  PDF: <FilePdfOutlined style={{ color: '#E53935' }} />,
  Image: <FileImageOutlined style={{ color: '#FFC107' }} />,
  Document: <FileWordOutlined style={{ color: '#2196F3' }} />,
  Sheet: <FileExcelOutlined style={{ color: '#4CAF50' }} />,
  PPT: <FilePptOutlined style={{ color: '#E53935' }} />,
  Unknown: <FileUnknownOutlined style={{ color: 'gray' }} />,
  MP4: <PlaySquareOutlined style={{ color: 'red' }} />,
  file: <FileTextOutlined style={{ color: 'black' }} />,
  workspace: <FileTextOutlined style={{ color: 'black' }} />,
  template: <FileTextOutlined style={{ color: 'black' }} />,
};

function AttachFileCard({ filename, filetype, previewUrl, style = {}, onRemove, showRemove = false }) {
  const isImageCard = filetype === 'Image' && previewUrl;
  const cardClassName = `filecard ${isImageCard ? 'filecard--image' : 'filecard'}`;
  const iconToDisplay = FILE_TYPE_ICONS[filetype] || FILE_TYPE_ICONS.Unknown;

  return (
    <Card
      bodyStyle={{ padding: '10px', cursor: 'pointer' }}
      style={{ ...style }}
      onClick={() => {
        if (previewUrl) {
          window.open(previewUrl, '_blank');
        }
      }}
    >
      <Flex direction="row" align="flex-start" justify="space-between" style={{ width: '100%' }}>
        <Text
          ellipsis={{ tooltip: filename }}
          style={{
            fontSize: '16px',
            fontWeight: '600',
            margin: '0px',
            padding: '0px',
            width: 'calc(100% - 20px)',
          }}
        >
          {filename}
        </Text>
        {showRemove && (
          <div
            style={{
              marginLeft: 8,
              cursor: 'pointer',
              width: 15,
              height: 15,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: 'rgba(0,0,0,0.85)',
              borderRadius: '50%',
              color: '#fff',
            }}
            onClick={(e) => {
              e.stopPropagation();
              onRemove?.();
            }}
          >
            <CloseOutlined style={{ fontSize: 8 }} />
          </div>
        )}
      </Flex>
      <Flex gap="small" align="center" style={{ marginTop: 8 }}>
        <div className="img">{iconToDisplay}</div>
        <Text
          style={{
            fontSize: '14px',
            fontWeight: '400',
            margin: '0px',
            padding: '0px',
            color: '#00000073',
          }}
        >
          {filetype}
        </Text>
      </Flex>
    </Card>
  );
}

export default AttachFileCard;
